module.exports = __webpack_public_path__ + "img/bonus_light_en.c77e8434.png";